export default __webpack_public_path__ + "static/media/logo.fd4744d0.png";